import Guid from "common/values/guid/guid";
import CompanyProfile, { CompanyProfileJSON } from "marketplace/values/company-profile/company-profile";

export interface CompanyJSON {
  id: string;
  entityId: string;
  profile?: CompanyProfileJSON;
  contactId?: string;
  isVisible?: boolean;
}

export default class Company {
  id: Guid;
  entityId: Guid;
  profile?: CompanyProfile;
  contactId?: Guid;
  isVisible: boolean;

  constructor(id: Guid, entityId: Guid, profile?: CompanyProfile, contactId?: Guid, isVisible?: boolean) {
    this.id = id;
    this.entityId = entityId;
    this.profile = profile;
    this.contactId = contactId;
    this.isVisible = isVisible ?? false;
  }

  public static fromJSON(json: CompanyJSON) {
    if (!json.id || json.id === '') {
      throw new Error("Company JSON is missing required 'id' field");
    }
    if (!json.entityId || json.entityId === '') {
      throw new Error("Company JSON is missing required 'entityId' field");
    }

    const id = Guid.fromJSON(json.id);
    const entityId = Guid.fromJSON(json.entityId);
    const profile = json.profile ? CompanyProfile.fromJSON(json.profile) : undefined;
    const contactId = json.contactId ? Guid.fromJSON(json.contactId) : undefined;
    const isVisible = Boolean(json.isVisible);

    return new Company(
      id,
      entityId,
      profile,
      contactId,
      isVisible
    );
  }

  public toJSON() {
    return {
      id: this.id.value,
      entityId: this.entityId.value,
      profile: this.profile?.toJSON(),
      contactId: this.contactId?.toString(),
      isVisible: this.isVisible
    }
  }
}
